class ConstructorVariantSelects extends VariantSelects {
    onVariantChange(event) {
        super.onVariantChange(event);
        this.syncConstructorAttributes();
    }

    syncConstructorAttributes() {
        const variant = this.currentVariant;
        const container = document.querySelector('[data-cnstrc-product-detail]');
        if (!container) return;

        if (!variant) {
            container.removeAttribute('data-cnstrc-item-variation-id');
            container.removeAttribute('data-cnstrc-item-price');
            return;
        }

        container.dataset.cnstrcItemVariationId = variant.id;
        container.dataset.cnstrcItemPrice = (variant.price / 100).toFixed(2);
    }
}

customElements.define('constructor-variant-selects', ConstructorVariantSelects);

/**
 * Constructor tracking for sticky variant selects.
 * Rather than overriding onVariantChange (which only syncs back to the main form),
 * we subscribe to PUB_SUB_EVENTS.variantChange — the same event the main
 * VariantSelects publishes after renderProductInfo() completes.
 * This ensures we always have the resolved variant with accurate price.
 */
if (
    !customElements.get('constructor-sticky-variant-selects') &&
    customElements.get('sticky-variant-selects')
) {
    customElements.define(
        'constructor-sticky-variant-selects',
        class ConstructorStickyVariantSelects extends StickyVariantSelects {
            connectedCallback() {
                super.connectedCallback();

                this.constructorVariantUnsubscriber = subscribe(
                    PUB_SUB_EVENTS.variantChange,
                    (event) => {
                        if (!event?.data?.variant) return;
                        this.syncConstructorAttributes(event.data.variant);
                    }
                );
            }

            disconnectedCallback() {
                super.disconnectedCallback();
                if (this.constructorVariantUnsubscriber) {
                    this.constructorVariantUnsubscriber();
                }
            }

            syncConstructorAttributes(variant) {
                const container = document.querySelector('[data-cnstrc-product-detail]');
                if (!container) return;

                if (!variant) {
                    container.removeAttribute('data-cnstrc-item-variation-id');
                    container.removeAttribute('data-cnstrc-item-price');
                    return;
                }

                container.dataset.cnstrcItemVariationId = variant.id;
                container.dataset.cnstrcItemPrice = (variant.price / 100).toFixed(2);
            }
        }
    );
}
